import React from "react";
import Footer from "./Footer";
import Section from "../section/Section";

export default function Layout() {
  return (
    <div>
      <Section></Section>
      <Footer></Footer>
    </div>
  );
}
